import { useQuery } from '@tanstack/react-query';

import getStudioList from 'Api/report-help-partner/getStudioList';

import getStudioListResponse from './model/response/getStudioListResponse';

const useGetStudioList = () => {
  return useQuery({
    queryKey: ['supervisor-studio-list'],
    queryFn: async () => {
      const response = await getStudioList();

      return getStudioListResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetStudioList;
